import ServiceMixin from 'Arch/mixins/ServiceMixin';
import NotificationRequest from 'Modules/contacard/communication/notifications/NotificationRequest';

export default {
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: NotificationRequest,
    entityDataConfig: {
      errorMessage: 'Falha ao buscar dados de noticações!',
      showSuccessSwal: false,
    },
    faultUpdateMessagesEntity: {
      successMessage: 'Sucesso ao atualizar notificações!',
      errorMessage: 'Falha ao atualizar notificações!',
    },
    faultSaveMessagesEntity: {
      successMessage: 'Sucesso ao criar notificações!',
      errorMessage: 'Falha ao criar notificações!',
    },
  }),
  computed: {
    getSaveOrUpdateNotificationRequest() {
      return (payload) => {
        if (this.isEdit) {
          return this.proxyRequest.edit(
            payload,
          );
        }
        return this.proxyRequest.save(payload);
      };
    },
    isEdit() {
      return Number(this.entityId) > 0;
    },
    entityId() {
      return this.$route.params.id;
    },
    proxyRequest() {
      return {
        edit: () => this.makeEditRequest(),
        save: () => this.makeSaveRequest(),
      };
    },
    config() {
      if (this.isEdit) {
        return this.faultUpdateMessagesEntity;
      }
      return this.faultSaveMessagesEntity;
    },
    getSaveNotificationRequest() {
      return () => this.requestClass.save(
        this.prepareNotificationPayload,
      );
    },
    getUpdateNotificationRequest() {
      return () => this.requestClass.edit(
        this.entityId,
        this.prepareNotificationPayload,
      ).then(
        () => ({
          data: {
            data: this.entityId,
          },
        }),
      );
    },
    getMessageRequest() {
      return (message, id) => {
        const { isToSend, faultRequest, mockRequest } = this.getFaultMessagesRequest(message, id);
        if (isToSend) {
          if (this.isEdit) {
            if (this.isSended) {
              if (this.isCreateMessage(message)) {
                return faultRequest();
              }
              return mockRequest;
            }
            return faultRequest();
          }
          return faultRequest();
        }
        return mockRequest;
      };
    },
    getFaultMessagesRequest() {
      return (message, id) => {
        const { saveOrUpdate, send } = this.prepareMessageMethods(message);
        const faultRequest = () => this.requestClass[saveOrUpdate](
          ...this.prepareMessageProperties(
            message,
            id,
          ),
        );
        return {
          faultRequest,
          mockRequest: Promise.resolve({}),
          isToSend: this.payload[send],
        };
      };
    },
    prepareMessageMethods() {
      return (message) => {
        const method = this.getMessageMethod(message);
        const camelCase = this.getMessageName(message);
        return {
          saveOrUpdate: `${method}${camelCase}`,
          send: `send${camelCase}`,
        };
      };
    },
    getMessageMethod() {
      return (message) => {
        if (!this.isEdit || this.isCreateMessage(message)) {
          return 'create';
        }
        return 'update';
      };
    },
    isCreateMessage() {
      return (message) => Number(this.payload[message].id) === 0;
    },
    isSentMessage() {
      return (send) => this.payload[send];
    },
    prepareMessageProperties() {
      return (message, communicationId) => {
        const { id, messageBody } = this.getMessageBody(message, communicationId);
        if (this.isEdit && !this.isCreateMessage(message)) {
          return [id, messageBody];
        }
        return [messageBody];
      };
    },
    getMessageBody() {
      return (message, communicationId) => {
        const { id, ...restMessageBody } = this.payload[message];
        const messageBody = {
          ...restMessageBody,
          communicationId,
        };
        return {
          messageBody,
          id,
        };
      };
    },
    isSended() {
      return this.payload.status === 'Sent';
    },
    getSendNotificationRequest() {
      return (id) => {
        if (!this.isSendOrSchedule) {
          return () => Promise.resolve({});
        }
        return () => this.requestClass.sendNotification(
          id,
          this.getSendNotificationBody,
        );
      };
    },
    isSendOrSchedule() {
      return this.isSend || this.status === 'Pending';
    },
    isSend() {
      return this.status === 'Sent';
    },
    getSendNotificationBody() {
      const {
        scheduledDate, sendPush, sendEmail, sendSms,
      } = this.payload;
      return {
        scheduledDate: this.isSended || this.isSend ? '' : scheduledDate,
        sendPush,
        sendEmail,
        sendSms,
      };
    },
    prepareNotificationPayload() {
      return {
        ...this.payload,
        status: this.getNotificationStatus,
      };
    },
    getNotificationStatus() {
      switch (this.status) {
        case 'Draft':
          return 'Pending';
        case 'Sent':
          return 'Pending';
        default:
          return this.status;
      }
    },
  },
  watch: {
    entityId: {
      immediate: true,
      handler() {
        if (this.isEdit) {
          this.getEntityData();
        }
      },
    },
  },
  methods: {
    getEntityData() {
      this.handleLoading();
      this.makeSetEntityDataRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeSetEntityDataRequest() {
      this.baseServiceRequest(
        this.requestClass.get(
          this.entityId,
        ),
        this.entityDataConfig,
        this.setEntityDataResponse,
      );
    },
    baseServiceRequest(request, ...props) {
      const { cb, config } = this.getServiceMixinProps(props);
      this.callService(
        request,
        cb,
        config,
      );
    },
    setEntityDataResponse(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.payload = this.overrideSetEntityData(
          this.overrideNullProperties(
            response.data,
            this.payload,
          ),
        );
      }
    },
    overrideSetEntityData(data = {}) {
      return {
        ...data,
        userFilter: this.prepareUserFilters(data.userFilter),
        userList: this.prepareUserList(data.userList),
      };
    },
    prepareUserFilters(filters) {
      const userFilters = this.tryParseOrReturnFault(
        filters,
        {},
      );
      this.emitUserNotificationFilters(userFilters);
      return userFilters;
    },
    tryParseOrReturnFault(item, fault) {
      try {
        const json = JSON.parse(item);
        return json;
      } catch (err) {
        return fault;
      }
    },
    emitUserNotificationFilters(filters = {}) {
      this.$nextTick(() => {
        this.$root.$emit('set-notifications-filters', filters);
      });
    },
    prepareUserList(list) {
      const userList = this.tryParseOrReturnFault(
        list,
        [],
      );
      this.emitUserNotificationList(userList);
      return userList;
    },
    emitUserNotificationList(list = []) {
      this.$nextTick(() => {
        this.$root.$emit('set-notifications-list', list);
      });
    },
    save() {
      this.handleLoading();
      this.makeSaveOrUpdateRequest();
    },
    makeSaveOrUpdateRequest() {
      this.baseServiceRequest(
        this.getSaveOrUpdateNotificationRequest(
          this.prepareNotificationPayload,
        ),
        this.config,
        this.handleLoading,
      );
    },
    makeSaveRequest() {
      return this.baseUpdateOrSaveRequest(
        this.getSaveNotificationRequest(),
      );
    },
    baseUpdateOrSaveRequest(request) {
      return this.makePromiseRequest(
        request,
        (response) => {
          if (this.hasData(response)) {
            return this.saveOrUpdateMessages(response.data.data);
          }
          throw new Error(this.faultSaveMessagesEntity.errorMessage);
        },
      );
    },
    makePromiseRequest(request, cb) {
      return new Promise(
        (resolve, reject) => {
          request.then(
            async (response) => {
              try {
                resolve(
                  await cb(response),
                );
              } catch (err) {
                reject(err);
              }
            },
          );
        },
      );
    },
    saveOrUpdateMessages(id) {
      return this.makePromiseRequest(
        Promise.all([
          this.getMessageRequest('sms', id),
          this.getMessageRequest('push', id),
          this.getMessageRequest('email', id),
        ]),
        this.getSendNotificationRequest(id),
      );
    },
    makeEditRequest() {
      return this.baseUpdateOrSaveRequest(
        this.getUpdateNotificationRequest(),
      );
    },
    getMessageName(message) {
      return String(message).split('')
        .map((key, i) => {
          if (i === 0) {
            return key.toUpperCase();
          }
          return key;
        }).join('');
    },
  },
};
